import React, {useEffect, useRef, useState} from "react";
import {selectors as accountSelectors} from "../../../Ducks/account";
import {actions as usersActions, selectors as usersSelectors} from "../../../Ducks/users";
import {bindActionCreators} from "redux";
import {selectors as eventsOverviewSelectors} from "../../../Ducks/eventsOverview";
import Typography from "@mui/material/Typography";
import {Autocomplete, Card, CardContent, IconButton, TextField as MaterialTextField} from "@mui/material";
import TeamsDropDowns from "../CaseOverview/Widgets/TeamsDropDowns";
import Grid from "@mui/material/Grid";
import {connect} from "react-redux";
import {cloneDeep} from "lodash";
import {withStyles} from "@mui/styles";
import {prepareFilterQuery} from "../../Utils/gridUtils";
import {getTodoOverview} from "../../../API/clientRetention";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import {AccountTreeOutlined, BusinessOutlined, Close, LinkedIn, PlaceOutlined} from "@mui/icons-material";
import PersonTodoList from "../ClientRetention/PersonTodoList";
import Box from "@mui/material/Box";
import logo from "../../../Assets/icons/f5-logo.svg";
import {ERP_BASE_URL} from "../../../API/util";
import moment from "moment/moment";
import {getProducts, getProductTypes} from "../../../API/products";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import LanguageIcon from "@mui/icons-material/Language";

const useStyles = _theme => ({
    container: {
        textAlign: 'left',
    },
    tabs: {
        marginTop: '0'
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    headline: {
        margin: '0 0 10px',
        minWidth: '300px',
        fontWeight: '400',
        fontSize: '20px',
        position: 'relative',
        flex: 1
    },
    stepper: {
        flex: 2
    },
    status: {
        color: '#fff',
        fontSize: '12px',
        textTransform: 'uppercase',
        fontWeight: '400',
        padding: '3px 10px',
        borderRadius: '4px',
        marginBottom: '4px',
        position: 'absolute',
        top: '11px'
    },
    opportunityID: {
        margin: '0 5px'
    },
    tabsStyling: {
        padding: '12px 0 !important',
        backgroundColor: '#f5f5f5 !important',
        color: '#3a3641 !important',
        border: '1px solid #dcdbdb !important',
        opacity: '1 !important',
        fontWeight: '600 !important',
        textTransform: 'capitalize'
    },
    selectBox: {
        marginLeft: '10px',
        padding: '10px'
    },
    attending: {
        background: '#68a54d',
        color: '#fff'
    },
    not_attending: {
        background: '#db6669',
        color: '#fff'
    },
    unknown: {
        background: '',
        color: '#000'
    },
    tentative: {
        background: '#f9fd01',
        color: '#000'
    },
    resale_attending: {
        background: '#5ecd5e',
        color: '#fff'
    },
    resale_not_attending: {
        background: '#e44848',
        color: '#fff'
    },
    resale_unknown: {
        background: '#e2e23b',
        color: '#000'
    },
    resale_tentative: {
        background: '#f1b851',
        color: '#000'
    },
    hide: {
        display: 'none'
    },
    form: {
        display: 'flex'
    },
    member: {
        position: 'relative'
    },
    indicator: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '15px',
        height: '15px',
        background: 'blue'
    },
    cardMedia: {
        borderRadius: '50%',
        maxWidth: '80px',
        margin: '15px auto 0'
    },
    card: {
        margin: '10px',
        cursor: 'pointer'
    },
    card_selected: {
        margin: '10px',
        cursor: 'pointer',
        backgroundColor: '#A1C8F0'
    },
});

function TodoOverview(props) {
    const {
        canViewTeamStats,
        team,
        resetTeamDetails,
        teamDetails,
        getTeamDetails,
        classes,
        user,
    } = props;
    const [teams, setTeams] = useState([]);
    const [filters, setFilters] = useState([]);
    const [personTodos, setPersonTodos] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [products, setProducts] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const userFilterHandled = useRef(false);

    useEffect(() => {
        fetchTeams();
        fetchProductTypes();
        fetchProducts();

        return () => {
            //This runs when the component unmounts
            resetTeamDetails();
        };
    }, []);

    useEffect(() => {
        if (team) {
            let _teams = team['rows']?.map((item) => {
                item.key = item.key
                item.label = item.team_name;
                return item;
            });

            setTeams(_teams);
        }
    }, [team]);

    useEffect(() => {
        if (!userFilterHandled.current) {
            if (filters.length === 0) {
                setFilters([{
                    id: "user_id",
                    value: user.user_details.user_id,
                }]);
                userFilterHandled.current = true;
                return;
            } else {
                const hasUserFilter = filters.some(item => item.id === "user_id");
                if (hasUserFilter) {
                    setFilters(filters.filter(item => item.id !== "user_id"));
                    userFilterHandled.current = true;
                    return;
                }
            }
        }

        fetchTodos();
        userFilterHandled.current = false;
    }, [filters]);

    useEffect(() => {
        setFilters([{
            id: "user_id",
            value: user.user_details.user_id,
        }]);
    }, [user]);

    const fetchTeams = () => {
        const {getTeams} = props;
        getTeams();
    }

    const fetchProductTypes = () => {
        getProductTypes().then(res => {
            if (res?.data?.main) {
                setProductTypes(res?.data?.main);
            }
        });
    }

    const fetchProducts = () => {
        getProducts({
            results: 500,
            columns: 'product_id,product_name',
            offset: 0,
        }).then(res => {
            if (res?.data?.main) {
                setProducts(res?.data?.main);
            }
        });
    }

    const fetchTodos = () => {
        let query = prepareFilterQuery(filters, []);

        if (query.length > 0) {
            query = query.slice(1);
            query = `?${query}`;
        }

        if (query?.length) {
            getTodoOverview(query).then((res) => {
                if (res?.data) {

                    const loadImageForItem = (item) => {
                        return new Promise((resolve) => {
                            const img = new Image();
                            const fallbackSrc = ERP_BASE_URL + "/uploads/images/persons/" + item.person_token + ".jpg";
                            const primarySrc = ERP_BASE_URL + "/uploads/images/persons/" + item.person_token + ".jpg";

                            img.src = primarySrc;

                            img.onload = () => {
                                item.person_image_exist = true;
                                item.person_image = primarySrc;
                                resolve(item);
                            };

                            img.onerror = () => {
                                const fallbackImg = new Image();
                                fallbackImg.src = fallbackSrc;

                                fallbackImg.onload = () => {
                                    item.person_image_exist = true;
                                    item.person_image = fallbackSrc;
                                    resolve(item);
                                };

                                fallbackImg.onerror = () => {
                                    item.person_image_exist = false;
                                    item.person_image = null;
                                    resolve(item);
                                };
                            };

                            if (img.complete) {
                                item.person_image_exist = true;
                                item.person_image = primarySrc;
                                resolve(item);
                            }
                        });
                    };

                    Promise.all(res.data.map(loadImageForItem)).then((updatedTodos) => {
                        setPersonTodos(updatedTodos);
                    });
                }
            });
        }
    }

    const filterTodosWithTeams = (filter) => {
        let _filters = cloneDeep(filters);
        let filterFound = false;

        _filters.forEach((item, index) => {
            if (filter) {
                if (filter.hasOwnProperty("user_id")) {
                    if (item.id === "user_id") {
                        item.value = filter.user_id;
                        filterFound = true;
                    } else if (item.id === "team_id") {
                        _filters.splice(index, 1, {
                            id: "user_id",
                            value: filter.user_id,
                        });
                        filterFound = true;
                    }
                } else if (filter.hasOwnProperty("team_id")) {
                    if (item.id === "team_id") {
                        item.value = filter.team_id;
                        filterFound = true;
                    } else if (item.id === "user_id") {
                        _filters.splice(index, 1, {
                            id: "team_id",
                            value: filter.team_id,
                        });
                        filterFound = true;
                    }
                } else if (filter.hasOwnProperty("product_type_id")) {
                    if (item.id === "product_type_id") {
                        if (filter.product_type_id !== undefined) {
                            item.value = filter.product_type_id;
                        } else {
                            _filters = _filters.filter((item) => {
                                return item.id !== "product_type_id"
                            });
                        }

                        filterFound = true;
                    }
                } else if (filter.hasOwnProperty("product_id")) {
                    if (item.id === "product_id") {
                        if (filter.product_id !== undefined) {
                            item.value = filter.product_id;
                        } else {
                            _filters = _filters.filter((item) => {
                                return item.id !== "product_id"
                            });
                        }

                        filterFound = true;
                    }
                }
            } else {
                if (["user_id", "team_id"].includes(item.id)) {
                    _filters.splice(index, 1);
                    filterFound = true;
                }
            }
        });

        if (!filterFound && filter) {
            if (filter.hasOwnProperty("team_id")) {
                _filters.push({id: "team_id", value: filter.team_id});
            } else if (filter.hasOwnProperty("user_id")) {
                _filters.push({id: "user_id", value: filter.user_id});
            } else if (filter.hasOwnProperty("product_type_id")) {
                _filters.push({id: "product_type_id", value: filter.product_type_id});
            } else if (filter.hasOwnProperty("product_id")) {
                _filters.push({id: "product_id", value: filter.product_id});
            }
        }

        setFilters(_filters);
    };

    const renderPersonTodoCardComponent = (person) => {

        return (
            <Card className={selectedPerson?.person_id === person.person_id ? classes.card_selected : classes.card}
                  sx={{position: "relative", width: "300px", height: "350px"}}
                  onClick={() => setSelectedPerson(person)}>
                <Grid container>
                    <Grid item xs={12} sx={{textAlign: 'right'}}>
                        <Box sx={{
                            position: "absolute",
                            top: 0,
                            right: 10,
                            backgroundColor: "#E7C4C3",
                            borderRadius: '5px',
                            color: "#E7C4C3",
                            padding: "5px 20px",
                            fontWeight: "bold",
                            transform: "skew(40deg)", // Slant effect
                        }}>ssss</Box>
                        <Box sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            backgroundColor: "#E7C4C3",
                            borderRadius: '5px',
                            color: "black",
                            padding: "3px 15px",
                            fontWeight: "bold",
                        }}>{person?.total_todos}/{person?.pending_todos}</Box>
                    </Grid>
                </Grid>
                <CardContent>
                    <Grid container sx={{paddingBottom: "20px"}}>
                        <Grid item xs={3}>
                            <CardMedia
                                className={classes.cardMedia}
                                component="img"
                                alt="person image"
                                image={person?.person_image_exist ? `${person?.person_image}` :
                                    `/assets/images/profile-placeholder.jpeg`}
                            />
                        </Grid>
                        <Grid item xs={9} sx={{textAlign: 'left'}}>
                            <Typography variant="subtitle1" component="div" gutterBottom
                                        sx={{margin: "20px 0px 0px 20px"}}>
                                {`${person?.person_firstname} ${person?.person_lastname}`}
                            </Typography>
                            <Typography variant="subtitle2" component="div" gutterBottom
                                        sx={{margin: "0px 0px 0px 20px"}}>
                                {person?.job_title}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider/>
                    <Grid container>
                        {
                            person?.product_name &&
                            <Grid item xs={12} sx={{marginTop: "20px", textAlign: 'left'}}>
                                <Grid container>
                                    <Grid item xs={1}>
                                        <AccountTreeOutlined color="gray"/>
                                    </Grid>
                                    <Grid item xs={11} sx={{paddingLeft: "15px"}}>
                                        {person?.product_name}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {
                            person?.person_region &&
                            <Grid item xs={12} sx={{textAlign: 'left'}}>
                                <Grid container>
                                    <Grid item xs={1}>
                                        <PlaceOutlined color="gray"/>
                                    </Grid>
                                    <Grid item xs={11} sx={{paddingLeft: "15px"}}>
                                        {person?.person_region}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {
                            person?.person_company && <Grid item xs={12} sx={{textAlign: 'left'}}>
                                <Grid container>
                                    <Grid item xs={1}>
                                        <BusinessOutlined color="gray"/>
                                    </Grid>
                                    <Grid item xs={11} sx={{paddingLeft: "15px"}}>
                                        {person?.person_company}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className={classes.container}>
            <div className={classes.title}>
                <h2 className={classes.headline}>
                    Todo Overview
                </h2>
            </div>
            <Grid container>
                {
                    (canViewTeamStats || user?.user_details?.team_lead) && <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-start'}}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={teams}
                                    sx={{width: 200, marginRight: '10px'}}
                                    onChange={(_event, value) => {
                                        if (value === null) {
                                            resetTeamDetails();
                                            filterTodosWithTeams();
                                        } else {
                                            resetTeamDetails();
                                            getTeamDetails({
                                                team_id: value?.team_id,
                                            });
                                            filterTodosWithTeams({
                                                team_id: value?.team_id,
                                            });
                                        }
                                    }}
                                    renderOption={(props, option, _state) => {
                                        return (
                                            <div {...props}>
                                                <div style={{
                                                    textAlign: 'left',
                                                    padding: '0',
                                                    fontSize: '13px',
                                                    borderBottom: '1px solid #eaeaea'
                                                }}>
                                                    <span>{`${option.label}`}</span>
                                                </div>
                                            </div>
                                        );
                                    }}
                                    renderInput={(params) => <MaterialTextField {...params} label="Teams"/>}
                                />
                                {teamDetails?.map((item, index) => (
                                    <TeamsDropDowns
                                        teamDetails={item}
                                        key={index}
                                        dropDownKey={index}
                                        getTeamDetails={getTeamDetails}
                                        resetTeamDetails={resetTeamDetails}
                                        filterWithTeamsCallback={filterTodosWithTeams}
                                    />
                                ))
                                }
                            </Grid>
                            <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    getOptionLabel={(option) => option.product_type_name}
                                    options={productTypes}
                                    sx={{width: 200, marginRight: '10px'}}
                                    onChange={(_event, value) => {
                                        filterTodosWithTeams({
                                            product_type_id: value?.product_type_id,
                                        });
                                    }}
                                    renderInput={(params) => <MaterialTextField {...params} label="Product Type"/>}
                                />
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    getOptionLabel={(option) => option.product_name}
                                    options={products}
                                    sx={{width: 200, marginRight: '10px'}}
                                    onChange={(_event, value) => {
                                        filterTodosWithTeams({
                                            product_id: value?.product_id,
                                        });
                                    }}
                                    renderInput={(params) => <MaterialTextField {...params} label="Product"/>}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid item xs={selectedPerson ? 6 : 12} sx={{pt: 8}}>
                    <Box sx={{
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        marginRight: '3px',
                        backgroundColor: "white",
                        borderRadius: "4px"
                    }}>
                        <Grid container>
                            {
                                personTodos?.map((personTodo) => (
                                    <Grid item key={personTodo.person_id}>
                                        {
                                            renderPersonTodoCardComponent(personTodo)
                                        }
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Box>
                </Grid>
                {
                    selectedPerson &&
                    <Grid item xs={6} sx={{pt: 8, pl: 1}}>
                        <Grid item xs={12} sx={{
                            textAlign: 'right',
                            backgroundColor: "white",
                            borderRadius: "4px"
                        }}>
                            <IconButton onClick={() => setSelectedPerson(null)}>
                                <Close/>
                            </IconButton>
                        </Grid>
                        <Box sx={{
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            backgroundColor: "white",
                            borderRadius: "4px"
                        }}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div style={{marginLeft: "20px"}}>
                                            <Typography variant='h6' component='div'>
                                                {selectedPerson.person_firstname} {selectedPerson.person_lastname}
                                            </Typography>
                                            {selectedPerson.title && (
                                                <Typography variant='body2' color='site.main'>
                                                    <BusinessCenterIcon sx={{color: "icon.main", fontSize: "20px"}}/>
                                                    <span style={{marginLeft: "8px"}}>{selectedPerson.title}</span>
                                                </Typography>
                                            )}
                                            {selectedPerson.person_region && (
                                                <Typography variant='body2' color='site.main'
                                                            className={classes.flexVertical}>
                                                    <LanguageIcon sx={{color: "icon.main", fontSize: "20px"}}/>
                                                    <span
                                                        style={{marginLeft: "8px"}}>{selectedPerson.person_region}</span>
                                                </Typography>
                                            )}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sx={{textAlign: 'right', pr: 1}}>
                                    <a target='_blank' href={selectedPerson.person_linkedin_url}>
                                        <LinkedIn sx={{color: "icon.linkedin", fontSize: "44px"}}/>
                                    </a>
                                    <a target='_blank'
                                       href={`${ERP_BASE_URL}/#/contacts/persons/` + selectedPerson.person_id}>
                                        <img alt='' src={logo} className='logo-link'></img>
                                    </a>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card sx={{m: 1, backgroundColor: '#f8F8F8', height: '233px'}}>
                                        <CardContent style={{paddingTop: '4'}}>
                                            <Typography>Event Info</Typography>
                                            <ul style={{padding: 0, mt: 1}}>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Name</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {selectedPerson?.event?.event_name}
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Start Time</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {moment(selectedPerson?.event?.event_start).format("HH:mm")}
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>End Time</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {moment(selectedPerson?.event?.event_stop).format("HH:mm")}
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Date</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {moment(selectedPerson?.event?.event_start).format("DD/MM/YYYY")}
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Address</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {selectedPerson?.event?.event_address}
                                                    </div>
                                                </li>
                                            </ul>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card sx={{m: 1, backgroundColor: '#f8F8F8', height: '233px'}}>
                                        <CardContent style={{paddingTop: '4'}}>
                                            <Typography>Rating</Typography>
                                            <ul style={{padding: 0, mt: 1}}>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>General</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {selectedPerson?.rating?.general}/10
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Recommendation</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {selectedPerson?.rating?.recommendation}/10
                                                    </div>
                                                </li>
                                                <li style={{display: 'flex', marginBottom: '5px', fontSize: '13px'}}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Unity</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {selectedPerson?.rating?.unity}/10
                                                    </div>
                                                </li>
                                                <li style={{
                                                    display: 'flex',
                                                    marginBottom: '5px',
                                                    fontSize: '13px',
                                                    width: '100%'
                                                }}>
                                                    <div style={{textTransform: 'capitalize', flex: 1}}>
                                                        <b>Response to Invitations</b>
                                                    </div>
                                                    <div style={{flex: 1}}>
                                                        {
                                                            selectedPerson?.rating?.response_to_invitations === 0 ? "Unknown" :
                                                                selectedPerson?.rating?.response_to_invitations === 1 ? "Attending" :
                                                                    selectedPerson?.rating?.response_to_invitations === -1 ? "Not Attending" : "Tentative"
                                                        }
                                                    </div>
                                                </li>
                                            </ul>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid container sx={{marginTop: "20px", padding: "20px"}}>
                                <Grid item xs={9}>
                                    <Typography
                                        variant='span'
                                        component='span'
                                        sx={{fontWeight: 'bold'}}>
                                        Todo Items
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography
                                        variant='span'
                                        component='span'
                                        sx={{fontWeight: 'bold'}}>
                                        Due Date
                                    </Typography>
                                </Grid>
                            </Grid>
                            <PersonTodoList todos={selectedPerson?.todos} person={selectedPerson?.person}
                                            jobEmail={selectedPerson?.person_job_email} type='history'/>
                        </Box>
                    </Grid>
                }
            </Grid>
        </div>
    );
}

const mapStateToProps = (state) => ({
    networkDirectors: eventsOverviewSelectors.networkDirectors(state),
    canViewTeamStats: accountSelectors.canViewTeamStats(state),
    team: usersSelectors.teams(state),
    teamDetails: usersSelectors.teamDetails(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getTeams: usersActions.getTeams,
        getTeamDetails: usersActions.getTeamDetails,
        resetTeamDetails: usersActions.resetTeamDetails,
    },
    dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(TodoOverview));